export default __webpack_public_path__ + "872d206bc9959ee5acd311f945845642.svg";